import { Badge, Text } from "@/shared/ui";

export function ApiNotice() {
  return (
    <div role="status" className="flex flex-wrap items-center gap-2 rounded-md bg-accent-subtle px-3 py-2">
      <Badge tone="teal" size="xs">Live workspace</Badge>
      <Text variant="body" as="p" className="text-[12.5px] text-ink-soft">
        Product review, planning, generation, regeneration, and private campaign-video composition run as durable account-scoped jobs.
      </Text>
    </div>
  );
}
